/**
 * Gets around using "setTimeout" scoping until we have all
 * async actions in our actions and redux stuff is straightened
 * out; makes our code more readable without a need for explicit
 * timers that need to be canceled or scoped
 *
 * @param p
 * @param p.time the amount of time in miliseconds before next action
 * @param p.checkCancelCondition callback to check whether next action should run
 * @returns {Promise|PromiseConstructor}
 */
export default p => {
    let time, checkCancelCondition

    switch (typeof p) {
        case 'number':
            time = p
            break
        case 'string':
            time = parseInt(p)
            break
        case 'object':
            if (p.hasOwnProperty('time')) {
                time = p.time
            }
            if (p.hasOwnProperty('checkCancelCondition')) {
                checkCancelCondition = p.checkCancelCondition
            }
            break
    }
    return new Promise((resolve, reject) => {
        if (typeof time !== 'number') {
            reject(new Error('wait function declared without a time'))
        }

        setTimeout(() => {
            if (typeof checkCancelCondition == 'undefined' || (checkCancelCondition && !checkCancelCondition())) {
                resolve() // run our action after waiting if available!
            } else return // otherwise never execute/resolve our next step
        }, time)
    })
}
